import { BaseRoutes } from './base.routes.constants';

export class CadastroCompletoRoutes extends BaseRoutes {
  constructor(route: string) {
    super(route);
  }
}
